import { render } from "./FreePackageHint.vue?vue&type=template&id=3e7a0b67"
import script from "./FreePackageHint.vue?vue&type=script&lang=js"
export * from "./FreePackageHint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__